import { render, staticRenderFns } from "./generalMeetingDetail.vue?vue&type=template&id=1f56129e&scoped=true&"
import script from "./generalMeetingDetail.vue?vue&type=script&lang=js&"
export * from "./generalMeetingDetail.vue?vue&type=script&lang=js&"
import style0 from "./generalMeetingDetail.vue?vue&type=style&index=0&id=1f56129e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56129e",
  null
  
)

export default component.exports